'use client'

import { Fragment } from "react"
import Blogs from "./Blogs"
import Products from "./Products"
import Hero from "./Hero"
import AllProducts from "./AllProducts"
import Categories from "./Categories"
import SubHeader from "../layout/SubHeader"
import { useHomeBlocks, type NormalizedHomeBlock } from "@/lib/commerce/hooks"

export default function Home({ vendor, homeBlocks: homeBlocksProp, subscription, activeCampaigns, categories }: { vendor: any, homeBlocks?: any[], subscription?: any, wishlist?: any, activeCampaigns?: any[], categories?: any[] }) {
  const blocks = useHomeBlocks({ vendor, homeBlocks: homeBlocksProp, subscription })
  const showStrip = !!(subscription?.canUseHeadBanner && vendor?.headBanner)
  const bannerIndex = blocks.findIndex(b => b.type === 'banner')
  const categoriesIndex = blocks.findIndex(b => b.type !== 'banner')
  const categorySection = <Categories categories={categories || []} />

  const renderBlock = (b: NormalizedHomeBlock, index: number) => {
    switch (b.type) {
    case 'banner':
      return <Hero vendor={vendor} activeCampaigns={activeCampaigns || []} overlay={index === 0} />
    case 'sale-products':
    case 'featured-products':
    case 'new-products':
    case 'category':
    case 'showcase':
      return <Products products={b.products || []} vendor={vendor} title={b.title || ''} limit={b.config?.limit} description={b.description} viewAllUrl={b.viewAllUrl} />
    case 'blogs':
      return <Blogs blogs={b.blogs || []} title={b.title} limit={b.config?.limit} description={b.description} />
    case 'all-products':
      return <AllProducts vendor={vendor} title={b.title} description={b.description} />
    default:
      return null
    }
  }

  return (
    <>
      {showStrip && bannerIndex === -1 && <SubHeader vendor={vendor} />}
      {blocks.map((b, index) => (
        <Fragment key={b.id}>
          {index === categoriesIndex && categorySection}
          {renderBlock(b, index)}
          {showStrip && index === bannerIndex && <SubHeader vendor={vendor} />}
        </Fragment>
      ))}
      {categoriesIndex === -1 && categorySection}
    </>
  )
}
